import { useState } from "react";
import { Card, Form, InputGroup, Badge } from "react-bootstrap";
import { BsCalendar2Date, BsCalendar2Month, BsTextareaResize } from "react-icons/bs";
import {
  FaRegCopy,
  FaCheck,
  FaLock,
  FaUser,
  FaEye,
  FaEyeSlash,
  FaGlobe,
  FaEnvelope,
  FaPhone,
  FaCalendarAlt,
  FaClock,
  FaHashtag,
  FaFile,
  FaLink,
} from "react-icons/fa";
import { GoNumber } from "react-icons/go";
import { LuCalendarClock } from "react-icons/lu";
import { MdAccessTime, MdLocationOn, MdOutlineMailOutline, MdOutlineTextFields } from "react-icons/md";

const AdditionalDetails = ({ itemData, activeItem, plateformSettings }) => {
  const [copiedField, setCopiedField] = useState(null);
  const [visiblePasswords, setVisiblePasswords] = useState({});

  const handleCopy = (e, text, field) => {
    e.stopPropagation();
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(null), 1500);
  };

  const renderCopyIcon = (field, value) =>
    copiedField === field ? (
      <FaCheck
        className="text-success"
        style={{ fontSize: 12 }}
      />
    ) : (
      <FaRegCopy
        className="text-muted"
        style={{ cursor: "pointer", fontSize: 12 }}
        title="Copy"
        onClick={(e) => handleCopy(e, value, field)}
      />
    );

  const getIconByType = (type) => {
    switch (type) {
      case "text":
        return MdOutlineTextFields;
      case "url":
        return FaGlobe;
      case "email":
        return MdOutlineMailOutline;
      case "phone":
        return FaPhone;
      case "number":
        return GoNumber;
      case "date":
        return BsCalendar2Date;
      case "month":
        return BsCalendar2Month;
      case "datetime-local":
        return LuCalendarClock;
      case "time":
        return MdAccessTime;
      case "textarea":
        return BsTextareaResize;
      case "file":
        return FaFile;
      case "password":
        return FaLock;
      default:
        return FaUser;
    }
  };

  return (
    <>
      {(itemData?.additionalInfo || [])?.length > 0 && (
        <Card className="shadow-sm mb-3 border">
          <Card.Header className="d-flex align-items-center gap-2 border-bottom">
            <strong style={{fontSize: 14}}>
              Additional Information
            </strong>
          </Card.Header>
          <Card.Body>
            {(itemData?.additionalInfo || [])
              .map((item, index) => {
                const isPassword = item?.type === "password";
                const isTextarea = item?.type === "textarea";
                const isUrl = item?.type === "url";
                const isFile = item?.type === "file";
                const fieldKey = `${item?.id}-${index}`;
                return (
                  <Form.Group key={fieldKey} className="mb-2">
                    {item?.label && (
                      <Form.Label className="small text-muted fw-bold mb-1" style={{fontSize: 13}}>
                        {item.label}
                      </Form.Label>
                    )}

                    <InputGroup>
                      <InputGroup.Text>
                        {(() => {
                          const Icon = getIconByType(item?.type);
                          return <Icon className="text-muted" style={{fontSize: 12}} />;
                        })()}
                      </InputGroup.Text>

                      {isTextarea ? (
                        <Form.Control
                          as="textarea"
                          rows={1}
                          readOnly
                          value={item?.value || "NA"}
                          className="interactive-input"
                          style={{ fontSize: 12, padding: "6px 15px" }}
                        />
                      ) : (
                        <Form.Control
                          className="interactive-input"
                          style={{ fontSize: 12, padding: "6px 15px" }}
                          value={item?.value || "NA"}
                          readOnly
                          size="sm"
                          type={
                            isPassword && !visiblePasswords[fieldKey]
                              ? "password"
                              : "text"
                          }
                        />
                      )}
                      {!(activeItem === "archived" || activeItem === "trash") &&
                        <>
                          {(!plateformSettings?.settings?.privacySettings?.hideShowConfidentialsDataOption && !plateformSettings?.settings?.showPrivacySettings?.hideShowConfidentialsDataOption) &&
                            <>
                              {isUrl && (
                                <InputGroup.Text
                                  style={{ cursor: "pointer" }}
                                  title={"View Website"}
                                >
                                  <a
                                    href={item?.value}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ fontSize: 12 }}
                                  >
                                    <FaLink />
                                  </a>
                                </InputGroup.Text>
                              )}
                              {isFile && (
                                <InputGroup.Text
                                  style={{ cursor: "pointer" }}
                                  title={"View File"}
                                >
                                  <a
                                    href={item?.value}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ fontSize: 12 }}
                                  >
                                    <FaLink />
                                  </a>
                                </InputGroup.Text>
                              )}
                              {isPassword && (
                                <InputGroup.Text
                                  role="button"
                                  onClick={() =>
                                    setVisiblePasswords((prev) => ({
                                      ...prev,
                                      [fieldKey]: !prev[fieldKey],
                                    }))
                                  }
                                >
                                  {visiblePasswords[fieldKey] ? (
                                    <FaEyeSlash style={{ fontSize: 12 }} />
                                  ) : (
                                    <FaEye style={{ fontSize: 12 }} />
                                  )}
                                </InputGroup.Text>
                              )}
                            </>
                          }
                          {(!plateformSettings?.settings?.privacySettings?.hideShowCopyOption && !plateformSettings?.settings?.showPrivacySettings?.hideShowCopyOption) &&
                            <InputGroup.Text>
                              {renderCopyIcon(fieldKey, item?.value)}
                            </InputGroup.Text>
                          }
                        </>
                      }
                    </InputGroup>
                  </Form.Group>
                );
              })}
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default AdditionalDetails;
